import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { Image, TouchableOpacity, Text } from "react-native";

import { styles } from "_components/common/UndoRedoButton.style.js";
import { Images } from "../../assets/";
import { View } from "react-native-web";
/**
 * TRASH ICON
 *
 * Common trash icon button for each notification, allows the user
 * to delete the notification.
 */
class IconButtons extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { imageName, buttonWithText, label, onPress, disabled } = this.props;
    return buttonWithText ? (
      <TouchableOpacity onPress={onPress} disabled={disabled}>
        <View style={[styles.buttonWrapper]}>
          <View style={[styles.textWrapper]}>
            <Text style={styles.buttonLabel}>{label}</Text>
          </View>
          <View style={styles.iconWrapper}>
            <Image style={[styles.iconStyleSmall]} source={Images[imageName]} />
          </View>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity onPress={onPress} disabled={disabled}>
        <Image style={[styles.iconStyle]} source={Images[imageName]} />
      </TouchableOpacity>
    );
  }
}

IconButtons.propTypes = {
  onClick: PropTypes.func.isRequired,
  imageName: PropTypes.any.isRequired,
};

export default connect(null, null)(IconButtons);
